import { Locale } from "date-fns";
import * as Locales from "date-fns/locale";

export class LocalesHelper {
    public static getLanguageCode(locale: string) {
        const [languageCode] = locale.split("-");
        return languageCode;
    }

    public static normalizeLocale(lng: string, removeDash = false) {
        const [lang, locale] = lng.split("-");
        return `${lang.toLowerCase()}${locale ? `${removeDash ? "" : "-"}${locale.toUpperCase()}` : ""}`;
    }

    public static loadDateFnsLocale(localeCode: string): Promise<Locale> {
        const normalizedLocale = LocalesHelper.normalizeLocale(localeCode, true);
        switch (normalizedLocale) {
            case "en":
            case "enCA":
            case "enUS":
                return Promise.resolve(Locales.enUS);
            case "fr":
            case "frFR":
                return Promise.resolve(Locales.fr);
            case "frCA":
                return Promise.resolve(Locales.frCA);
            case "es":
                return Promise.resolve(Locales.es);
            case "pt":
            case "ptBR":
                return Promise.resolve(Locales.ptBR);
            default:
                return Promise.resolve(Locales.enUS);
        }
    }
}
